import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import InitLayout from './Init'
import MainLayout from './Main'
// import {useAuth0} from "../contexts/auth0-context";
import { useAuth0 } from '@auth0/auth0-react'
import { useData } from '../contexts/data-context'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  init: InitLayout,
}

const mapStateToProps = ({ settings }) => ({ settings })
let previousPath = ''

const Layout = ({ children, location: { pathname, search } }) => {
  const { isLoading } = useAuth0()
  const { isApiLoading, connectors, init_status, product, active_products } = useData()

  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  // setTimeout(() => {
  //   NProgress.done()
  //   previousPath = currentPath
  // }, 300)

  const isSection = (section) => {
    const re = new RegExp('^/' + section + '(?=/|$)', 'i')
    return re.test(pathname)
  }
  // Layout Rendering
  const getLayout = () => {
    if (isSection('public')) {
      return 'public'
    }
    if (isSection('auth')) {
      return 'auth'
    }
    if (isSection('init')) {
      return 'init'
    }
    return 'main'
  }

  const needsToConnect = () => {
    const not_connected = connectors && !connectors.some((c) => c.authenticated)
    return pathname !== '/init/connect' && pathname !== '/invite-users' && not_connected
  }

  const needsToProcess = () => {
    return pathname !== '/init/connect' && pathname !== '/init/processing' && init_status === 'processing'
  }

  const isReady = () => {
    return (
      (pathname === '/init/processing' || pathname === '/init/expired') && init_status === 'ready'
    )
  }

  const hasExpired = () => {
    return product !== "hctranslate" && pathname !== '/init/expired' && pathname !== '/payment' && pathname !== '/invite-users' && init_status === 'expired'
  }

  const layout = getLayout()
  const requiresLogin = layout === 'init' || layout === 'main'
  const Container = Layouts[layout]
  const isUserLoading = isLoading === true || isApiLoading === true
  const pathToProduct = {
    '/auth/easydoc': 'easydoc',
    '/auth/hcmanager': 'hcmanager',
    '/auth/hcanalytics': 'hcanalytics',
    '/auth/hctranslate': 'hctranslate',
    '/auth/mergedup': 'mergedup',
    '/auth/removecc': 'removecc',
    '/auth/attachments': 'attachments',
  }
  const selectedProduct = product || pathToProduct[pathname]

  const titleTemplate = {
    answersearch: 'Answer Search by Swifteq | %s',
    easydoc: 'Help Center Export for Zendesk Guide | %s',
    hcmanager: 'Help Center Manager for Zendesk | %s',
    hctranslate: 'Help Center Translate for Zendesk | %s',
    hcanalytics: 'Help Center Analytics for Zendesk | %s',
    mergedup: 'Merge Duplicates for Zendesk Support | %s',
    removecc: 'Remove CC from Zendesk Tickets | %s',
    attachments: 'Attachment Workflows for Zendesk | %s',
  }

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (requiresLogin && (!init_status || isUserLoading)) {
      return null
    }

    if (hasExpired()) {
      return <Redirect to="/init/expired" />
    }
    if ((init_status !== 'expired' || product === "hctranslate") && (active_products||[]).indexOf(product)>=0 && needsToConnect()) {
      return <Redirect to="/init/connect" />
    }
    if (init_status !== 'expired' && needsToProcess()) {
      return <Redirect to="/init/processing" />
    }
    if (init_status !== 'expired' && isReady()) {
      return <Redirect to="/" />
    }
    NProgress.done()
    previousPath = currentPath

    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet
        titleTemplate={titleTemplate[selectedProduct]}
        title={titleTemplate[selectedProduct]}
      />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
